<template>
  <div>
    <ui-heading tag="h3" no-top-margin>
      {{ $t("submission_for_compliance_reviews_heading") }}
    </ui-heading>
    <ui-field
      v-if="submissionComment"
      :label="$t('compliance_reviews.submissionForComplianceReviews.inquery')"
      label-position="inline"
      bottom-margin="small"
    >
      {{ submissionComment }}
    </ui-field>
    <ui-field
      label-position="inline"
      :label="
        $t('compliance_reviews.submissionForComplianceReviews.submittedBy')
      "
      bottom-margin="small"
    >
      {{ submitterEmail || "-" }}
      <div>{{ dateCreated }}</div>
    </ui-field>
    <div class="resolution-info-container">
      <ui-field
        v-if="resolution"
        label-position="inline"
        :label="
          $t('compliance_reviews.submissionForComplianceReviews.resolution')
        "
        bottom-margin="small"
      >
        {{ resolution }}
      </ui-field>
      <ui-field
        v-if="resolutionComment"
        label-position="inline"
        :label="
          $t(
            'compliance_reviews.submissionForComplianceReviews.resolutionComment'
          )
        "
        bottom-margin="small"
      >
        {{ resolutionComment }}
      </ui-field>
    </div>
    <compliance-review-history
      v-if="shouldShowHistory"
      :history-list="complianceReviewHistoryList"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { actions, getters } from "@/store";
import { documentDateFormat } from "@/utils/date";
import ComplianceReviewHistory from "./ComplianceReviewHistory.vue";

export default {
  data() {
    return {
      reviewHistory: null
    };
  },
  components: {
    ComplianceReviewHistory
  },
  computed: {
    ...mapGetters([getters.complianceReviewItem, getters.complianceReviewList]),

    dateCreated() {
      return documentDateFormat(
        new Date(this.complianceReviewNewestItem?.createdUtc)
      );
    },

    resolution() {
      return this.complianceReviewNewestItem?.resolution
        ? this.$t(
            `compliance_reviews.resolutionStatus.${this.complianceReviewNewestItem.resolution}`
          )
        : null;
    },

    filterPayload() {
      return {
        kycIdentificationId: this.complianceReviewItem.kycIdentificationId // "23e69da1c34d40b6bb83668e853e5b91"
      };
    },

    complianceReviewNewestItem() {
      return this.complianceReviewList[0];
    },

    complianceReviewHistoryList() {
      return this.complianceReviewList.filter(
        item => item.id !== this.complianceReviewNewestItem.id
      );
    },

    submissionComment() {
      return this.complianceReviewNewestItem?.submissionComment;
    },

    submitterEmail() {
      return this.complianceReviewNewestItem?.submitterEmail;
    },

    resolutionComment() {
      return this.complianceReviewNewestItem?.resolutionComment;
    },

    shouldShowHistory() {
      return this.complianceReviewHistoryList?.length;
    }
  },

  watch: {
    filterPayload: {
      handler() {
        this.fetchHistory();
      },
      immediate: true
    }
  },

  methods: {
    ...mapActions([actions.getComplianceReviewList, actions.notificationAdd]),

    async fetchHistory() {
      await this.getComplianceReviewList(this.filterPayload);
    }
  }
};
</script>
<style scoped>
.resolution-info-container {
  padding-top: 1rem;
}
</style>
